import { Property } from "./interfaces";

export const codDiagnosticoRelacionado: Property = {
  title: "Código de Diagnóstico Relacionado",
  type: "string",
};
